import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { Field } from 'redux-form';
import { propArrayShape, propBool, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import { getFormError, getFormErrorsFirst } from '../../../../helpers/form';
import InputError from '../InputError';
import PlainInputComponent from '../PlainInputComponent';
const MultiInputFields = (props) => {
    const { className, form, settings, showError, spacer, wrapClassName } = props;
    const error = getFormErrorsFirst(form, settings.map((s) => s.name));
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: wrapClassName }, { children: settings.map((item, index) => (_jsxs(Fragment, { children: [_jsx(Field, { component: PlainInputComponent, name: item.name, props: {
                                className: `input-form-text ${className || ''} ${getFormError(form, item.name) ? 'is-warning' : ''}`,
                                id: item.id || item.name,
                                maxLength: item.maxLength || null,
                                placeholder: item.placeholder,
                                showError: false,
                                type: item.type || 'text',
                            }, validate: item.validate || [] }), index !== settings.length - 1 && spacer] }, item.name))) })), showError && _jsx(InputError, { error: error })] }));
};
MultiInputFields.propTypes = {
    className: propStr(),
    form: propShape().isRequired,
    settings: propArrayShape().isRequired,
    showError: propBool(),
    spacer: propStr(),
    wrapClassName: propStr(),
};
MultiInputFields.defaultProps = {
    className: '',
    showError: true,
    spacer: '',
    wrapClassName: '',
};
export default MultiInputFields;
